// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1-eOH","title":"Images45_title__-NM8U","images":"Images45_images__2FbqO"};